import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';
import connect from '../../utils/connect';

class Video extends Component {
	static propTypes = {};

	componentDidMount() {
		let isMobile = (this.props.browser.window.width <= 719);
		if (isMobile && this.refs.video) {
			this.refs.video.setAttribute('playsInline', true);
			this.refs.video.play();
		}
	}

	render() {
		let isMobile = (this.props.browser.window.width <= 719);
		let classNames = classnames({
			video: true,
		}, this.props.className);

		return (
			<div className={classNames}>
				<video ref="video" autoPlay={!isMobile} muted loop preload="auto">
					<source src={this.props.video} type="video/mp4" />
					<div>Your browser does not support the video tag.</div>
				</video>
			</div>
		);
	}
}

export default connect(Video);



/** WEBPACK FOOTER **
 ** ./frontend/components/image/video.js
 **/